import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { environment } from '../environments/environment';
import { MessagingService } from './core/services/messaging.service';
import { PopupService } from './core/services/util/popup.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  filter,
  map,
  mergeMap,
  skipWhile,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { SEOService } from './core/services/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import {
  LanguageService,
  defaultLanguages,
} from './core/services/language.service';
import { NotificationService } from './core/services/notification.service';
import { IUser } from './core/models/user.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  isFirsttime = false;
  language = 'en';
  loggedInUser: IUser;
  highPriorityNotification = null;
  notificationContent = null;
  selectedNotifcation = null;
  notificationId = null;

  constructor(
    private authService: AuthService,
    private messagingService: MessagingService,
    private popupService: PopupService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _seoService: SEOService,
    private translateService: TranslateService,
    private title: Title,
    private languageService: LanguageService,
    private notificationService: NotificationService
  ) {
    // this.title.setTitle(localStorage.getItem('title'));
    this.language = languageService.currentLanguage;
  }

  ngOnInit() {
    if (environment.production) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      const { notificationId } = params;

      if (notificationId) {
        this.notificationId = notificationId;
      }

      // notificationId && this.removeParameters();
    });

    this.authService.autoLogin();

    this.authService.isAuthenticated
      .pipe(
        filter((value) => value),
        switchMap((_) =>
          this.authService.LoggedinUser.pipe(
            filter((user) => user !== null),
            take(1)
          )
        )
      )
      .subscribe((res) => {
        this.loggedInUser = res;
        console.log(this.loggedInUser);
        this.loadNotifications();
      });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        const message = event.data;

        if (message?.action === 'open_notification') {
          // Handle the data passed from the notification
          if (this.loggedInUser) {
            this.getUserNotification(message.data.id);
            // this.selectedNotifcation = message.data;
            // this.loadNotifications();
          } else {
            this.notificationService.setNotification(message.data);
            this.selectedNotifcation = message.data;
          }
        } else {
          // for vehicle notifications
          this.messagingService.currentMessage.next(event.data);
        }
      });
    }

    this.languageService.Language.subscribe((lang) => {
      console.log('lang: ' + lang);
      this.language = lang;
    });

    let firsttime = localStorage.getItem('firsttimeCard');

    if (firsttime === null || firsttime === undefined) {
      localStorage.setItem('firsttimeCard', 'true');

      let date2 = new Date('January 05, 2023 23:30:00');

      if (Date.now() < date2.getTime()) {
        this.popupService.setState(true);
        this.isFirsttime = true;
        setTimeout(() => {
          this.statusBar();
        }, 100);
      }
    } else {
      localStorage.setItem('firsttimeCard', 'false');
      this.popupService.setState(false);
      this.isFirsttime = false;
    }

    // this.router.events.pipe(
    //   filter((event) => event instanceof NavigationEnd),
    //   map(() => this.activatedRoute),
    //   map((route) => {
    //     while (route.firstChild) route = route.firstChild;
    //     return route;
    //   }),
    //   filter((route) => route.outlet === 'primary'),
    //   mergeMap((route) => route.data)
    // )
    //   .subscribe((event) => {
    //     console.log(event)
    //     this.translateService.get([event['title'], event['description']]).subscribe(res => {
    //       const values: string[] = Object.values(res);
    //       this._seoService.updateTitle(values[0]);
    //       this._seoService.updateDescription(`${values[0]} | ${values[1]}`)
    //       localStorage.setItem('title', values[0]);
    //     });
    //   });
  }

  removePopup() {
    this.popupService.setState(false);
    this.isFirsttime = false;
  }

  statusBar() {
    let timerId, percent;

    // reset progress bar
    percent = 0;
    const div = document.querySelector('.progress') as HTMLElement;

    timerId = setInterval(function () {
      // increment progress bar
      percent += 0.4;
      if (div) div.style.width = percent + '%';

      // complete
      if (percent >= 100) {
        clearInterval(timerId);

        // do more ...
        const popup = document.querySelector('.popup') as HTMLElement;
        if (popup) {
          popup.classList.remove('fade-in-image');
          popup.classList.add('fade-out');
        }
      }
    }, 50);
  }

  loadNotifications() {
    this.notificationService
      .getUserNotifications(this.loggedInUser.id)
      .subscribe(
        (res) => {
          this.notificationService.updateNotifications(res);

          if (this.selectedNotifcation || this.notificationId) {
            this.highPriorityNotification = res?.results?.find(
              (notification) =>
                notification.notificationId === this.selectedNotifcation?.id ||
                notification.notificationId === this.notificationId
            )?.notification;

            this.selectedNotifcation = null;
          } else {
            const filteredNotifications =
              res?.results?.filter(
                (notification) =>
                  notification.notification.priority === 'high' &&
                  !notification.isSeen
              ) || [];

            if (filteredNotifications.length > 0) {
              this.highPriorityNotification =
                filteredNotifications[
                  filteredNotifications.length - 1
                ]?.notification;
            }
          }

          console.log(this.highPriorityNotification);

          if (this.highPriorityNotification) {
            const { languageContents } = this.highPriorityNotification;

            const lang = defaultLanguages.find(
              (lng) => lng.name === this.language
            );

            const defaultLanguage = 'english';
            this.notificationContent =
              languageContents.find(
                (content) => content.language === lang.label
              ) ||
              languageContents.find(
                (content) => content.language === defaultLanguage
              );

            this.markNotificationAsSeen();
          }
        },
        (err) => {}
      );
  }

  getUserNotification(notificationId: string) {
    this.notificationService
      .getUserNotification(this.loggedInUser.id, notificationId)
      .subscribe(
        (notification: any) => {
          if (notification) {
            this.highPriorityNotification = notification.notification;

            const { languageContents } = this.highPriorityNotification;

            const lang = defaultLanguages.find(
              (lng) => lng.name === this.language
            );

            const defaultLanguage = 'english';
            this.notificationContent =
              languageContents.find(
                (content) => content.language === lang.label
              ) ||
              languageContents.find(
                (content) => content.language === defaultLanguage
              );

            this.markNotificationAsSeen();
          }
        },
        (err) => {}
      );
  }

  removeParameters() {
    const paramsToRemove = ['notificationId'];

    // Get the current query parameters
    const currentParams = { ...this.activatedRoute.snapshot.queryParams };

    // Remove specified parameters
    paramsToRemove.forEach((param) => delete currentParams[param]);

    // Navigate to the same route without the specified parameters
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: currentParams,
      queryParamsHandling: 'merge',
    });
  }

  markNotificationAsSeen() {
    const body = {
      isSeen: true,
    };

    this.notificationService
      .updateUserNotification(
        this.loggedInUser.id,
        this.highPriorityNotification.id,
        body
      )
      .subscribe(
        (res) => {},
        (err) => {}
      );
  }
}
